module.exports = () => ({
  name: {
    label: '用户',
    type: 'input',
    value: '',
  },
});
